import type { Theme, SxProps, Breakpoint } from '@mui/material/styles';

import { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import { useTheme } from '@mui/material/styles';


import { Iconify } from 'src/components/iconify';

import { Main } from './main';
import { layoutClasses } from '../classes';
import { NavMobile, NavDesktop } from './nav';
import { navData } from '../config-nav-dashboard';

type Role = keyof typeof navData;
import { LayoutSection } from '../core/layout-section';
import { HeaderSection } from '../core/header-section';
import { AccountPopover } from '../components/account-popover';
import { Logo } from 'src/components/logo';
import { createLinearGradient, hexToRgbChannel } from 'src/theme/styles';
import { useStore } from 'src/store/StoreContext';
import { IconButton, Typography } from '@mui/material';
import { usePatient } from 'src/store/userContext';

// ----------------------------------------------------------------------

export type DashboardLayoutProps = {
  sx?: SxProps<Theme>;
  children: React.ReactNode;
  header?: {
    sx?: SxProps<Theme>;
  };
};

export const DashboardLayout =({ sx, children, header }: DashboardLayoutProps)  =>{
  const theme = useTheme();

  const [navOpen, setNavOpen] = useState(false);

  const store = useStore();

  const user = store?.user;
  const service = store?.service;

  const patient = usePatient();

    const getWelcomeMessage = () => {
        const { role : userRole, given_name } = user?.user || {};
        const role = userRole?.toLowerCase();
        if (!role || !given_name) return 'Welcome';
        if (role.includes('doctor')) return `Welcome Dr. ${given_name}`;
        if (role.includes('superadmin')) return `Welcome Super Admin ${given_name}`;
        if (role.includes('admin')) return `Welcome Admin ${given_name}`;
        return `Welcome ${given_name}`;
    }

    useEffect(() => {
      const { role : userRole,  nameid } = user?.user || {};
      async function getPatientDetails(){
        patient?.setUserId(typeof nameid === 'string' ? parseInt(nameid, 10) : nameid ?? 0);
       await  patient?.getPatients();
      }
      const role = userRole?.toLowerCase();
      if(role && role.includes('patient')){
        getPatientDetails();
      }
    }, [])

    useEffect(() => {
      const { role : userRole,  nameid } = user?.user || {};
      const role = userRole?.toLowerCase();
      if(role && role.includes('patient')){
        service?.updatePatient(patient?.selectedPatient?.id ?? null);
      }
    }, [patient?.selectedPatient])
    
    
  const layoutQuery: Breakpoint = 'md';

  return (
    <LayoutSection
      headerSection={
        <HeaderSection
          layoutQuery={layoutQuery}
          slotProps={{
            container: {
              maxWidth: 'xl',
            },
            toolbar:{
              sx:{
                  backgroundColor:'transparent',
              }
          }
          }}
          sx={{
            backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        backgroundImage: createLinearGradient(hexToRgbChannel(theme.palette.primary.light,true),hexToRgbChannel(theme.palette.primary.light,true), 0.4, 0.2, 270)
          }}
          slots={{
            leftArea: (
              <>
                  
                <NavMobile
                  data={user?.user?.role ? navData[user.user.role.toLowerCase() as Role] : []}
                  open={navOpen}
                  onClose={() => setNavOpen(false)}
                />
                 <IconButton onClick={() => setNavOpen(true)} sx={{ mr: 1, color: 'text.primary', display: { lg: 'none' } }}>
                    <Iconify icon="eva:menu-2-fill" />
                </IconButton>
                <Logo href={store?.user.user ? `/${store?.user.user?.role.toLowerCase()}` : '/'} />
              </>
            ),
            rightArea: (
              <Box gap={1} display="flex" alignItems="center">
                <Typography sx={{display: { xs: 'none',md:'block' }}} variant='h5'>
                {getWelcomeMessage()}
                </Typography>
                <AccountPopover
                  // data={[
                  //   {
                  //     label: 'Home',
                  //     href: '/',
                  //     icon: <Iconify width={22} icon="fluent-color:home-16" />,
                  //   },
                  // ]}
                />
              </Box>
            ),
          }}
        />
      }
 
      sidebarSection={
        <NavDesktop data={user?.user?.role ? navData[user.user.role.toLowerCase() as Role] : []} layoutQuery={layoutQuery} />
      }
      footerSection={null}
      cssVars={{
        '--layout-nav-vertical-width': '100px',
        '--layout-dashboard-content-pt': theme.spacing(1),
        '--layout-dashboard-content-pb': theme.spacing(8),
        '--layout-dashboard-content-px': theme.spacing(5),
        ...(user?.user?.role?.toLowerCase() === 'patient' || user?.user?.role?.toLowerCase() === 'admin' ? {
          '--layout-nav-zIndex': 50,
          '--layout-header-zIndex': 99,
        } : {}),
      }}
      sx={{
        [`& .${layoutClasses.hasSidebar}`]: {
          [theme.breakpoints.up(layoutQuery)]: {
            // pl: 'var(--layout-nav-vertical-width)',
          },
        },
        ...sx,
      }}
    >
      <Main>{children}</Main>
    </LayoutSection>
  );
}
